// extracted by mini-css-extract-plugin
export var linkText = "_p1-0";